export default __webpack_public_path__ + "static/gcores-696a0dbfefaa4f60c2ec0bbdb5e58841.png";